/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { PaymentMethodType } from '../types/utils';
import { UserID } from './user-model';

export type PaymentMethodID = string;

export class PaymentMethod {
	id: PaymentMethodID = ''

	BIC?: string

	IBAN?: string

	name: string = ''

	type: PaymentMethodType = PaymentMethodType.WIRE_TRANSFER

	userId: UserID = ''

	visible?: boolean
}